import { Auth } from 'aws-amplify';
import { Loader } from 'components';
import { useInfoPopup } from 'hooks';
import { setSentryUser } from 'lib/sentry';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearHeaders } from 'services';
import { postChangeEmail } from 'services/user';
import { setAnalyticsUserId } from 'utils/analytics';

import {
  MessageContainer,
  VerifyingLoaderSlot,
  VerifyingState,
} from '../styled';
import { CognitoError, getAmplifyAuthErrorMessage } from '../utils';

const ChangeEmailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { showInfoPopup } = useInfoPopup();

  const onFailure = (error: CognitoError) => {
    const title = getAmplifyAuthErrorMessage(t, error);

    showInfoPopup({
      type: 'error',
      title: title === t('auth.userNotFound') ? t('auth.codeExpired') : title,
    });
    navigate('/');
  };

  useEffect(() => {
    const search = new URLSearchParams(location.search);
    const code = search.get('c');
    const userName = search.get('u');
    const newEmail = search.get('m');

    if (!code || !userName || !newEmail) {
      showInfoPopup({
        type: 'error',
        title: t('errors.invalidRequest'),
      });
      navigate('/');
    }

    (async () => {
      postChangeEmail(userName, code, newEmail)
        .then(() => {
          showInfoPopup({
            type: 'success',
            title: t('auth.confirmed'),
          });
          setAnalyticsUserId(null);
          setSentryUser(null);
          Auth.signOut();
          clearHeaders();
          navigate('/');
        })
        .catch((err) => {
          onFailure(err);
        });
    })();
  }, []);

  return (
    <VerifyingState>
      <VerifyingLoaderSlot>
        <Loader size="56px" type={null} />
      </VerifyingLoaderSlot>
      <MessageContainer>{t('auth.verifying')}</MessageContainer>
    </VerifyingState>
  );
};

export default ChangeEmailPage;
